<template>
    <div id="search">
        <div class="row justify-content-md-center">
            <div class="col-12 col-md-4">
                <input type="text" v-model="searchText"  placeholder="Buscar" class="form-control">
                <br>
            </div>
        </div>
        <div class="row" v-if="searchResults.length >= 1">
            <div class="col-12">
                <form action="">
                    <p v-if="searchText.length > 0">
                        {{ searchResults.length }} resultados para: <strong>{{ searchText }}</strong>
                    </p>
                </form>
            </div>
            <div class="col-12 col-md6 col-lg-4" v-for="(result, index) in filterSearchResults()" :key="index" v-if="searchResults.length > 0">
                <cardTemplate :dataContent="result" @deleteCard="updateList(index)"></cardTemplate>
            </div>
        </div>
        <div class="row" v-else-if="searchResults.length == 0 && searchText.length > 0">
            <div class="col-12 text-center">
                <br>
                <h4>Nenhum resultado encontrato</h4>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import cardTemplate from './CardTemplate'
export default {
    name: 'search',
    data (){
        return {
            searchText: '',
            searchResults: [],
            ROOT_API: null
        }
    },
    components: {
        cardTemplate,
    },
    methods:{
        filterSearchResults
    },
    created(){
        this.ROOT_API = process.env.ROOT_API
    },
    watch:{
        searchText(){
            if(this.searchText.length >= 1){
                let totalData = ''
                let siteId = this.$session.get('siteId')
                let token = this.$session.get('jwt')
                let searchWord = this.searchText
                axios ({
                    method: 'get',
                    url: this.ROOT_API+'/api/site/'+siteId+'/post/search?q='+searchWord,
                    data:  totalData,
                    headers: {
                        'Authorization': 'Bearer '+token,
                        // 'Content-Type': 'application/x-www-form-urlencoded' 
                    }
                })
                .then(response => {
                    this.searchResults = response.data.content
                })
                .catch(function (response) {
                    console.log('Erro ao buscar posts')
                })
            }
        }
    }
}
function filterSearchResults(){
    // return this.searchResults.filter(result => result.visible > 0)
    return this.searchResults
}
</script>




// WEBPACK FOOTER //
// src/components/Search.vue